import { inject } from "ui-common/di";
import type { IRpcService } from "ui-common/services/rpc/types";
import type { AnalyticsResult } from "api-contracts/rpc/analytics";
import type { IWritableAnalyticsDataState, IAnalyticsDataService, AnalyticsLoadParams } from "./types";

export class AnalyticsDataService implements IAnalyticsDataService {
  @inject<IWritableAnalyticsDataState>("writableAnalyticsDataState")
  private state!: IWritableAnalyticsDataState;

  @inject<IRpcService>("rpcService")
  private rpcService!: IRpcService;

  private pendingLoad: Promise<void> | undefined;

  loadAnalytics(params: AnalyticsLoadParams): void {
    if (this.pendingLoad) return;

    this.state.loading.set(true);
    this.pendingLoad = this.doLoad(params);
  }

  refetch(params: AnalyticsLoadParams): void {
    this.pendingLoad = undefined;
    this.state.loading.set(true);
    this.pendingLoad = this.doLoad(params);
  }

  private async doLoad(params: AnalyticsLoadParams): Promise<void> {
    try {
      const result = await this.rpcService.call<AnalyticsResult>("analytics", {
        startDate: params.startDate,
        endDate: params.endDate,
        filter: params.filter,
      });
      this.state.data.set(result);
    } catch (error) {
      console.error("[AnalyticsDataService] Error loading analytics:", error);
    } finally {
      this.state.loading.set(false);
      this.pendingLoad = undefined;
    }
  }
}
